var jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/util');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');

// require('jquery-sticky');
require('@fortawesome/fontawesome-free');

// window.initDatePickers = () => {
//     $('.datepicker').datetimepicker({
//         format: 'DD/MM/YYYY',
//         showTodayButton: true,
//         showClear: true
//     });
// }

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
$(function() {

    // Initialise the Ajax functions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // $('.selectpicker').selectpicker();

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').on('click',function() {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('active');

        if($(this).hasClass('active')){
            $(this).find('.icon').text('close');
        }else{
            $(this).find('.icon').text('menu');
        }

    });

    // $('.scrollup').click(function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });

    // $(window).scroll(function () {
    //     if ($(this).scrollTop() > 200) {
    //         $('#page-top').fadeIn();
    //     } else {
    //         $('#page-top').fadeOut();
    //     }
        
    // });
    // Search Filters Datepicker
    // Using font-awesome 5 icons
    $.extend(true, $.fn.datetimepicker.defaults, {
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'far fa-calendar-check',
          clear: 'far fa-calendar-times',
          close: 'far fa-times-circle'
        }
    });
    $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false //Important! See issue #1075
    });

    $('.datepicker-start').on("dp.change", function (e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });
    $('.datepicker-end').on("dp.change", function (e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });


    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    // download quote pdf loading state
    $('.download-pdf').on('click', function(e){
        $(this).attr('disabled', true).addClass('disabled').html('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Downloading...');

        setCookie('downloadStarted', 0, 100); //Expiration could be anything... As long as we reset the value
        setTimeout(checkDownloadCookie, 1000); //Initiate the loop to check the cookie.
    });

    var downloadTimeout;
    var checkDownloadCookie = function() {
      if (getCookie("downloadStarted") == 1) {
        setCookie("downloadStarted", "false", 100); //Expiration could be anything... As long as we reset the value

        $('.download-pdf').attr('disabled', false).removeClass('disabled').html('<i class="material-icons md-18 mr-2">picture_as_pdf</i> Download PDF');

      } else {
        downloadTimeout = setTimeout(checkDownloadCookie, 1000); //Re-run this function in 1 second.
      }
    };

});

var setCookie = function(name, value, expiry) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + expiry * 1000);
  var c_value = escape(value) + ((expiry == null) ? "" : "; expires=" + exdate.toUTCString());
  document.cookie = name + "=" + c_value + '; path=/';
};

var getCookie = function(name) {
  var i, x, y, ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == name) {
      return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
    }
  }
};

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}



// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js